/* ============================================================

   KAFFEESACK WARENKORB — CONVERSION FEATURES v17
   Datei: assets/kaffeesack-cart.js

   ============================================================
   ANLEITUNG FÜR MITARBEITER
   ============================================================

   In diesem Bereich könnt ihr die Aktionen und
   Empfehlungen anpassen. Ab "NICHTS MEHR ÄNDERN"
   bitte nichts verändern.

   KAFFEE DES MONATS WECHSELN:
   1. In Shopify: Altes Produkt → Tag entfernen
   2. Neues Produkt → Tag hinzufügen (siehe unten)
   3. Speichern. Fertig!
      (Das Datum berechnet sich automatisch auf den
       letzten Tag des aktuellen Monats um Mitternacht.)

   RABATTCODE FÜR KAFFEE DES MONATS:
   Der Rabattcode wird automatisch angewendet wenn
   ein Kunde den Kaffee des Monats hinzufügt.
   Aktueller Code: kaffeedesmonats26
   (In Shopify unter "Rabatte" angelegt.)

   ============================================================ */

var defined_KS_CONFIG = {

  /* ---- KAFFEE DES MONATS ---- */
  monthly: {
    tag:             'kaffee-des-monats',
    badge:           'Kaffee des Monats',
    discountCode:    'kaffeedesmonats26',
    discountPercent: 10,
    timerText:       'Nur noch für kurze Zeit: ',
    confirmedText:   'Gesichert! Noch ',
    confirmedSuffix: ' verfügbar.',
    addBtnText:      'Jetzt sichern'
  },

  /* ---- VERSAND & RABATT ---- */
  shipping: {
    freeShippingCents: 8000,    /* 80,00 € — ab hier kostenloser Versand */
    discountThresholdCents: 12000, /* 120,00 € — ab hier 5% Rabatt */
    discountPercent: 5
  },

  /* ---- LIMITIERTES PRODUKT (Banner im Warenkorb) ---- */
  limited: {
    handle:       '',
    badge:        'Limitierte Röstung',
    claim:        '',
    addBtnText:   'Jetzt entdecken',
    emoji:        '🔥'
  },

  /* ---- EMPFEHLUNGEN ---- */
  recs: {
    headline:           'Das könnte dir auch gefallen',
    limit:              2,
    addBtnText:         'Hinzufügen',
    fallbackCollection: 'all'
  }
};


/* ============================================
   AB HIER NICHTS MEHR ÄNDERN
   ============================================ */

(function() {
  'use strict';

  /* === HELPERS === */

  /* === 1KG VARIANTE BEVORZUGEN === */
  function prefer1kg(product) {
    if (!product.variants || !product.variants.length) return product.variants ? product.variants[0] : null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var t = (v.title || '').toLowerCase().replace(/\s+/g, '');
      if ((t.indexOf('1kg') !== -1 || t.indexOf('1000g') !== -1 || t.indexOf('1000gramm') !== -1) && v.available !== false) {
        return v;
      }
    }
    /* Fallback: erste verfügbare Variante */
    for (var j = 0; j < product.variants.length; j++) {
      if (product.variants[j].available !== false) return product.variants[j];
    }
    return product.variants[0];
  }

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function toCents(val) {
    if (!val && val !== 0) return 0;
    var s = String(val);
    return s.indexOf('.') !== -1 ? Math.round(parseFloat(s) * 100) : (parseInt(s, 10) || 0);
  }

  function formatMoney(cents) {
    var e = Math.floor(Math.abs(cents) / 100);
    var c = Math.abs(cents) % 100;
    return (cents < 0 ? '-' : '') + '\u20AC' + e + ',' + (c < 10 ? '0' : '') + c + ' EUR';
  }

  function getImgSrc(product, size) {
    var src = '';
    if (product.images && product.images.length) {
      var f = product.images[0];
      src = typeof f === 'string' ? f : (f.src || f.url || '');
    } else if (product.image) {
      src = typeof product.image === 'string' ? product.image : (product.image.src || product.image.url || '');
    }
    return src ? src.replace(/\.([a-z]+)(\?.*)?$/i, '_' + size + '.$1$2') : '';
  }

  function getEndOfMonth() {
    var n = new Date();
    return new Date(n.getFullYear(), n.getMonth() + 1, 0, 23, 59, 59);
  }

  function getTimeStr(end) {
    var diff = end - new Date();
    if (diff <= 0) return null;
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    return d > 0 ? d + 'T ' + pad(h) + 'Std ' + pad(m) + 'Min' : pad(h) + 'Std ' + pad(m) + 'Min';
  }

  /* === GLOBAL STATE === */
  var _monthlyHandles = [];

  /* === FETCH === */

  function fetchByTag(tag) {
    var results = [];
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var list = data.products || [];
          if (!list.length) return results;
          list.forEach(function(p) {
            var tags = Array.isArray(p.tags)
              ? p.tags.map(function(t) { return String(t).trim().toLowerCase(); })
              : String(p.tags || '').split(',').map(function(t) { return t.trim().toLowerCase(); });
            if (tags.indexOf(tag.toLowerCase()) !== -1) results.push(p);
          });
          return list.length === 250 ? page(n + 1) : results;
        });
    }
    return page(1);
  }

  function fetchRecs(ids, handles, limit) {
    var seen = {};
    handles.forEach(function(h) { seen[h] = true; });
    _monthlyHandles.forEach(function(h) { seen[h] = true; });
    /* Limited-Produkt aus Empfehlungen ausschließen */
    var limitedHandle = (defined_KS_CONFIG.limited || {}).handle;
    if (limitedHandle) seen[limitedHandle] = true;
    var all = [];
    function go(i) {
      if (i >= ids.length || all.length >= limit) return Promise.resolve(all.slice(0, limit));
      return fetch('/recommendations/products.json?product_id=' + ids[i] + '&limit=10&intent=related')
        .then(function(r) { return r.ok ? r.json() : { products: [] }; })
        .then(function(d) {
          (d.products || []).forEach(function(p) {
            if (!seen[p.handle] && all.length < limit && p.available) {
              seen[p.handle] = true;
              all.push(p);
            }
          });
          return go(i + 1);
        })
        .catch(function() { return go(i + 1); });
    }
    return go(0);
  }

  function fetchCollection(handle, handles, limit) {
    return fetch('/collections/' + handle + '/products.json?limit=20')
      .then(function(r) {
        return r.ok ? r.json() : fetch('/products.json?limit=20').then(function(r2) { return r2.json(); });
      })
      .then(function(d) {
        var seen = {};
        handles.forEach(function(h) { seen[h] = true; });
        _monthlyHandles.forEach(function(h) { seen[h] = true; });
        var limitedHandle = (defined_KS_CONFIG.limited || {}).handle;
        if (limitedHandle) seen[limitedHandle] = true;
        return (d.products || []).filter(function(p) {
          return !seen[p.handle] && p.available;
        }).slice(0, limit);
      })
      .catch(function() { return []; });
  }

  /* ============================================
     ADD TO CART — AJAX (kein Reload!)
     Optional: discountCode wird automatisch angewendet
     ============================================ */

  function addToCart(vid, btn, discountCode) {
    var orig = btn.innerHTML;
    btn.innerHTML = '\u2026'; btn.disabled = true; btn.style.opacity = '0.7';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      /* Rabattcode automatisch anwenden wenn vorhanden */
      if (discountCode) {
        return fetch('/discount/' + encodeURIComponent(discountCode), {
          credentials: 'same-origin'
        }).catch(function() { /* ignore */ });
      }
    })
    .then(function() {
      btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
      btn.classList.add('ks-btn--done');
      btn.style.opacity = '1';
      setTimeout(function() { refreshCartDrawer(); }, 600);
    })
    .catch(function() {
      btn.innerHTML = orig; btn.disabled = false; btn.style.opacity = '1';
    });
  }

  /* ============================================
     AJAX CART DRAWER REFRESH
     ============================================ */

  function refreshCartDrawer() {
    var cart = document.querySelector('#ks-cart');
    if (!cart) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cartData) {

        var handles = cartData.items.map(function(i) { return i.handle; });
        var ids = cartData.items.map(function(i) { return String(i.product_id); });
        cart.setAttribute('data-ks-cart-handles', handles.join(','));
        cart.setAttribute('data-ks-product-ids', ids.join(','));
        cart.setAttribute('data-ks-cart-total', String(cartData.total_price));
        cart.setAttribute('data-ks-item-count', String(cartData.item_count));

        /* Count */
        var countEl = cart.querySelector('[data-ks-count]');
        if (countEl) countEl.textContent = '(' + cartData.item_count + ')';

        /* Totals */
        var totalEl = cart.querySelector('[data-cart-total]');
        if (totalEl) totalEl.textContent = formatMoney(cartData.total_price);
        var btnTotal = cart.querySelector('[data-ks-btn-total]');
        if (btnTotal) btnTotal.textContent = formatMoney(cartData.total_price);

        /* Original total / discounts */
        var origRow = cart.querySelector('[data-cart-original-total]');
        if (origRow) {
          if (cartData.original_total_price > cartData.total_price) {
            origRow.classList.remove('is-hidden');
            var origPrice = origRow.querySelector('[data-cart-original-total-price]');
            if (origPrice) origPrice.textContent = formatMoney(cartData.original_total_price);
          } else {
            origRow.classList.add('is-hidden');
          }
        }

        /* Shipping bar + Truck */
        updateShippingBar(cart, cartData.total_price);

        /* Empty state */
        var empty = cart.querySelector('[data-empty-message]');
        if (empty) {
          if (cartData.item_count > 0) empty.classList.add('is-hidden');
          else empty.classList.remove('is-hidden');
        }

        /* Site-Header Cart Count */
        updateHeaderCount(cartData.item_count);

        /* Items via Section Rendering API */
        return fetch('/cart?section_id=api-cart-items', { credentials: 'same-origin' })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var itemsHolder = cart.querySelector('[data-items-holder]');
            if (itemsHolder && html) {
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              var content = tmp.querySelector('[data-api-content]');
              if (content) {
                itemsHolder.innerHTML = content.innerHTML;
              }
            }

            /* Re-render Monthly + Limited + Recs */
            var monthly = cart.querySelector('[data-ks-monthly]');
            if (monthly) renderMonthly(monthly, handles);

            var limited = cart.querySelector('[data-ks-limited]');
            if (limited) renderLimited(limited, handles);

            var recs = cart.querySelector('[data-ks-recs]');
            if (recs) renderRecs(recs, ids, handles);
          });
      })
      .catch(function(e) {
        console.log('[KS] Cart refresh error:', e);
      });
  }

  /* === UPDATE SHIPPING BAR — DUAL MILESTONE === */

  function initShippingBar(cart) {
    var shipping = cart.querySelector('.ks-shipping');
    if (!shipping || shipping.hasAttribute('data-ks-dual-init')) return;
    shipping.setAttribute('data-ks-dual-init', '1');

    var cfg = defined_KS_CONFIG.shipping || {};
    var shippingLimit = cfg.freeShippingCents || parseInt(cart.getAttribute('data-ks-shipping-limit') || '0', 10);
    var discountLimit = cfg.discountThresholdCents || shippingLimit;
    var discountPct = cfg.discountPercent || 5;

    /* Sortiere: erstes Ziel (niedriger) und zweites Ziel (höher) */
    var maxVal = Math.max(shippingLimit, discountLimit);

    /* Merke Werte auf dem Element */
    shipping.setAttribute('data-ks-shipping-limit', String(shippingLimit));
    shipping.setAttribute('data-ks-discount-limit', String(discountLimit));
    shipping.setAttribute('data-ks-discount-pct', String(discountPct));

    /* Milestones nach Wert sortieren */
    var milestones = [];
    if (shippingLimit === discountLimit) {
      /* Gleiche Schwelle: ein kombinierter Marker */
      milestones.push({ type: 'combined', value: shippingLimit, emoji: '\uD83D\uDE9A', label: discountPct + '% + Gratis' });
    } else {
      milestones.push({ type: 'shipping', value: shippingLimit, emoji: '\uD83D\uDE9A', label: 'Gratis ab ' + fmt(shippingLimit) });
      milestones.push({ type: 'discount', value: discountLimit, emoji: '\uD83C\uDFF7\uFE0F', label: discountPct + '% Rabatt' });
      milestones.sort(function(a, b) { return a.value - b.value; });
    }

    /* HTML aufbauen */
    var h = '';
    h += '<p class="ks-shipping__text" data-ks-shipping-text></p>';
    h += '<div class="ks-shipping__track">';
    h += '<div class="ks-shipping__track-bg"></div>';
    h += '<div class="ks-shipping__fill" data-cart-progress></div>';

    for (var i = 0; i < milestones.length; i++) {
      var m = milestones[i];
      var pos = Math.round((m.value / maxVal) * 100);
      h += '<div class="ks-shipping__milestone ks-shipping__milestone--' + m.type + '" data-ks-milestone-' + m.type + ' style="left:' + pos + '%">';
      h += '<div class="ks-shipping__milestone-icon">' + m.emoji + '</div>';
      h += '<span class="ks-shipping__milestone-label">' + m.label + '</span>';
      h += '</div>';
    }

    h += '</div>';
    h += '<div style="height:12px"></div>';

    shipping.innerHTML = h;
  }

  function updateShippingBar(cart, totalPrice) {
    var shipping = cart.querySelector('.ks-shipping');
    if (!shipping) return;

    if (!shipping.hasAttribute('data-ks-dual-init')) initShippingBar(cart);

    var shippingLimit = parseInt(shipping.getAttribute('data-ks-shipping-limit') || '0', 10);
    var discountLimit = parseInt(shipping.getAttribute('data-ks-discount-limit') || '0', 10);
    var discountPct = parseInt(shipping.getAttribute('data-ks-discount-pct') || '5', 10);
    var maxVal = Math.max(shippingLimit, discountLimit);
    if (!maxVal) return;

    var percent = Math.min(100, Math.round((totalPrice / maxVal) * 100));
    var discountReached = totalPrice >= discountLimit;
    var shippingReached = totalPrice >= shippingLimit;
    var leftToDiscount = Math.max(0, discountLimit - totalPrice);
    var leftToShipping = Math.max(0, shippingLimit - totalPrice);
    var allDone = discountReached && shippingReached;

    /* Welches Ziel kommt zuerst? */
    var firstIsShipping = shippingLimit <= discountLimit;

    /* Bar-Füllung */
    var fill = shipping.querySelector('[data-cart-progress]');
    if (fill) {
      fill.style.width = percent + '%';
      fill.classList.toggle('ks-shipping__fill--done', allDone);
    }

    /* Milestone-Icons aktualisieren */
    var mShipping = shipping.querySelector('[data-ks-milestone-shipping]');
    if (mShipping) {
      var iconS = mShipping.querySelector('.ks-shipping__milestone-icon');
      mShipping.classList.toggle('is-reached', shippingReached);
      if (iconS) iconS.textContent = shippingReached ? '\u2713' : '\uD83D\uDE9A';
    }

    var mDiscount = shipping.querySelector('[data-ks-milestone-discount]');
    if (mDiscount) {
      var iconD = mDiscount.querySelector('.ks-shipping__milestone-icon');
      mDiscount.classList.toggle('is-reached', discountReached);
      if (iconD) iconD.textContent = discountReached ? '\u2713' : '\uD83C\uDFF7\uFE0F';
    }

    var mCombined = shipping.querySelector('[data-ks-milestone-combined]');
    if (mCombined) {
      mCombined.classList.toggle('is-reached', allDone);
      var iconC = mCombined.querySelector('.ks-shipping__milestone-icon');
      if (iconC) iconC.textContent = allDone ? '\u2713' : '\uD83D\uDE9A';
    }

    /* Text — kontextabhängig */
    var textEl = shipping.querySelector('[data-ks-shipping-text]');
    if (!textEl) return;

    if (allDone) {
      textEl.className = 'ks-shipping__text ks-shipping__text--done';
      textEl.innerHTML = '\uD83C\uDF89 <strong>' + discountPct + '% Rabatt</strong> + <strong>Gratis-Versand</strong> gesichert!';
    } else if (shippingLimit === discountLimit) {
      /* Gleiche Schwelle */
      textEl.className = 'ks-shipping__text';
      textEl.innerHTML = '\uD83C\uDFAF Noch <strong>' + fmt(leftToShipping) + '</strong> bis <strong>' + discountPct + '% Rabatt + Gratis-Versand</strong>';
    } else if (firstIsShipping) {
      /* Versand zuerst (80€), dann Rabatt (120€) */
      if (!shippingReached) {
        textEl.className = 'ks-shipping__text';
        textEl.innerHTML = '\uD83D\uDE9A Noch <strong>' + fmt(leftToShipping) + '</strong> bis <strong>Gratis-Versand</strong>';
      } else {
        textEl.className = 'ks-shipping__text';
        textEl.innerHTML = '\u2705 Gratis-Versand! Noch <strong>' + fmt(leftToDiscount) + '</strong> bis <strong>' + discountPct + '% Rabatt</strong> \uD83C\uDFF7\uFE0F';
      }
    } else {
      /* Rabatt zuerst, dann Versand */
      if (!discountReached) {
        textEl.className = 'ks-shipping__text';
        textEl.innerHTML = '\uD83C\uDFF7\uFE0F Noch <strong>' + fmt(leftToDiscount) + '</strong> bis <strong>' + discountPct + '% Rabatt</strong>';
      } else {
        textEl.className = 'ks-shipping__text';
        textEl.innerHTML = '\u2705 ' + discountPct + '% Rabatt aktiv! Noch <strong>' + fmt(leftToShipping) + '</strong> bis <strong>Gratis-Versand</strong> \uD83D\uDE9A';
      }
    }
  }

  /* === UPDATE HEADER CART COUNT === */

  function updateHeaderCount(count) {
    var sels = [
      '[data-cart-count]', '.cart-count', '.cart__count',
      '.site-nav__cart-count', '.js-cart-count', '.header__cart-count'
    ];
    sels.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.textContent = count;
      });
    });
  }

  /* === DISCOUNT === */

  function initDiscount(cart) {
    var input = cart.querySelector('[data-ks-discount-input]');
    var btn = cart.querySelector('[data-ks-discount-btn]');
    var msg = cart.querySelector('[data-ks-discount-msg]');
    if (!input || !btn) return;

    function showMsg(text, isError) {
      if (!msg) return;
      msg.textContent = text;
      msg.className = 'ks-discount__msg' + (isError ? ' ks-discount__msg--err' : ' ks-discount__msg--ok');
      msg.style.display = 'block';
    }

    function norm(s) { return s.toLowerCase().replace(/[\s_-]/g, ''); }

    function codeInCart(cartData, code) {
      var n = norm(code);
      var found = false;
      (cartData.cart_level_discount_applications || []).forEach(function(d) {
        if (norm(d.title) === n) found = true;
      });
      if (!found) {
        (cartData.items || []).forEach(function(item) {
          (item.discount_allocations || []).forEach(function(da) {
            if (da.discount_application && norm(da.discount_application.title) === n) found = true;
          });
        });
      }
      return found;
    }

    function apply() {
      var code = input.value.trim();
      if (!code) { input.focus(); return; }
      if (msg) msg.style.display = 'none';

      var origTxt = btn.innerHTML;
      btn.innerHTML = '\u2026'; btn.disabled = true;
      var totalBefore;

      /* 1) Cart-Zustand VORHER holen */
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(before) {
          totalBefore = before.total_price;

          /* Schon aktiv? */
          if (codeInCart(before, code)) {
            btn.innerHTML = origTxt; btn.disabled = false;
            showMsg('Dieser Rabattcode ist bereits aktiv.', false);
            input.value = '';
            return;
          }

          /* 2) Code an Shopify senden */
          return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
            .then(function() {
              /* 3) Kurz warten damit Shopify den Rabatt verarbeitet */
              return new Promise(function(resolve) { setTimeout(resolve, 400); });
            })
            .then(function() {
              /* 4) Cart-Zustand NACHHER prüfen */
              return fetch('/cart.js', { credentials: 'same-origin' })
                .then(function(r) { return r.json(); });
            })
            .then(function(after) {
              btn.innerHTML = origTxt; btn.disabled = false;

              /* Erfolg = Name taucht auf ODER Preis ist gesunken */
              if (codeInCart(after, code) || after.total_price < totalBefore) {
                showMsg('Rabattcode angewendet!', false);
                input.value = '';
                refreshCartDrawer();
              } else {
                showMsg('Ungültiger Rabattcode.', true);
                input.focus();
                input.select();
              }
            });
        })
        .catch(function() {
          btn.innerHTML = origTxt; btn.disabled = false;
          showMsg('Fehler — bitte erneut versuchen.', true);
        });
    }
    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  }

  /* === EXPRESS CHECKOUT DIVIDER === */
  function addExpressDivider(cart) {
    var footer = cart.querySelector('.ks-footer');
    if (!footer || footer.querySelector('.ks-express-divider')) return;
    var expressButtons = footer.querySelector('.additional-checkout-buttons');
    if (!expressButtons) return;
    var divider = document.createElement('div');
    divider.className = 'ks-express-divider';
    divider.textContent = 'oder';
    expressButtons.parentNode.insertBefore(divider, expressButtons);
  }

  /* === TRUST BADGES === */
  function addTrustBadges(cart) {
    var footer = cart.querySelector('.ks-footer');
    if (!footer || footer.querySelector('.ks-trust')) return;
    var cont = footer.querySelector('.ks-continue');
    var trust = document.createElement('div');
    trust.className = 'ks-trust';
    trust.innerHTML = '<span>\uD83D\uDD12 Sichere Zahlung</span><span>\uD83D\uDE9A Schneller Versand</span><span>\u2615 Frisch ger\u00f6stet</span>';
    if (cont) {
      footer.insertBefore(trust, cont);
    } else {
      footer.appendChild(trust);
    }
  }

  /* === VARIANTEN-PICKER HELFER === */

  /* Prüft ob ein Optionswert die große Variante (1kg/1000g) ist */
  function isLargeSizeValue(raw) {
    var v = (raw || '').toLowerCase().replace(/\s+/g, '');
    return v === '1kg' || v === '1000g' || v === '1000gramm' ||
           v.indexOf('1kg') === 0 || v.indexOf('1000g') === 0 || v.indexOf('1000gramm') === 0;
  }

  /* Findet die passende Variante anhand gewählter Optionen */
  function findVariant(product, selected) {
    if (!product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var k = 0; k < selected.length; k++) {
        var optKey = 'option' + (k + 1);
        if (v[optKey] !== selected[k]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* Erstellt die Standard-Auswahl (1000 Gramm bevorzugt) */
  function getDefaultSelections(product) {
    var opts = product.options || [];
    var selections = [];
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i];
      var vals = opt.values || [];
      var picked = vals[0] || '';
      /* Bei Gewicht: 1000 Gramm bevorzugen */
      for (var j = 0; j < vals.length; j++) {
        if (isLargeSizeValue(vals[j])) { picked = vals[j]; break; }
      }
      selections.push(picked);
    }
    return selections;
  }

  /* Baut HTML für Varianten-Dropdowns */
  function buildPickerHTML(product, uid) {
    var opts = product.options || [];
    if (opts.length <= 1 && product.variants && product.variants.length <= 1) return '';
    var defaults = getDefaultSelections(product);
    var visibleOpts = [];
    for (var i = 0; i < opts.length; i++) {
      if ((opts[i].values || []).length > 1) visibleOpts.push({ opt: opts[i], idx: i });
    }
    if (!visibleOpts.length) return '';
    var h = '<div class="ks-picker" data-ks-picker="' + uid + '">';
    for (var k = 0; k < visibleOpts.length; k++) {
      var opt = visibleOpts[k].opt;
      var idx = visibleOpts[k].idx;
      var vals = opt.values || [];
      h += '<div class="ks-picker__field">';
      h += '<span class="ks-picker__label">' + (opt.name || 'Option') + '</span>';
      h += '<select class="ks-picker__select" data-ks-option="' + idx + '">';
      for (var j = 0; j < vals.length; j++) {
        var sel = (vals[j] === defaults[idx]) ? ' selected' : '';
        h += '<option value="' + vals[j].replace(/"/g, '&quot;') + '"' + sel + '>' + vals[j] + '</option>';
      }
      h += '</select>';
      h += '</div>';
    }
    h += '</div>';
    return h;
  }

  /* Aktiviert Change-Events auf den Picker-Dropdowns */
  function wirePicker(container, product, uid, discountCode) {
    var picker = container.querySelector('[data-ks-picker="' + uid + '"]');
    if (!picker) return;
    var selects = picker.querySelectorAll('select[data-ks-option]');
    var card = picker.closest('[data-ks-product-card]');
    if (!card) return;
    var btn = card.querySelector('[data-ks-add]');
    var priceEl = card.querySelector('[data-ks-price]');

    function update() {
      var opts = product.options || [];
      var selected = [];
      for (var i = 0; i < opts.length; i++) {
        var sel = picker.querySelector('select[data-ks-option="' + i + '"]');
        selected.push(sel ? sel.value : (opts[i].values ? opts[i].values[0] : ''));
      }
      var v = findVariant(product, selected);
      if (v && btn) {
        btn.setAttribute('data-ks-add', v.id);
        if (v.available === false) {
          btn.disabled = true;
          btn.textContent = 'Ausverkauft';
        } else {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-ks-btn-text') || 'Hinzufügen';
        }
      }
      if (v && priceEl) {
        priceEl.textContent = fmt(toCents(v.price));
      }
    }

    selects.forEach(function(s) { s.addEventListener('change', update); });
    update(); /* Initial */
  }

  /* === RENDER: KAFFEE DES MONATS === */

  function renderMonthly(container, cartHandles) {
    var cfg = defined_KS_CONFIG.monthly;
    if (!cfg || !cfg.tag) return;
    var endDate = getEndOfMonth();
    var timeStr = getTimeStr(endDate);
    if (!timeStr) return;

    fetchByTag(cfg.tag).then(function(products) {
      if (!products.length) return;

      _monthlyHandles = products.map(function(p) { return p.handle; });

      var inCart = products.filter(function(p) { return cartHandles.indexOf(p.handle) !== -1; });
      var hasAll = products.length > 0 && inCart.length === products.length;
      var notInCart = products.filter(function(p) { return cartHandles.indexOf(p.handle) === -1; });
      var discountPercent = cfg.discountPercent || 0;
      var discountCode = cfg.discountCode || '';

      var h = '<div class="ks-monthly' + (hasAll ? ' ks-monthly--confirmed' : '') + '">';

      /* Überschrift mit Rabatt-Badge */
      h += '<div class="ks-monthly__heading">';
      h += '<span class="ks-monthly__heading-icon">\u23F0</span>';
      h += '<p class="ks-monthly__heading-text">' + cfg.badge + '</p>';
      if (discountPercent > 0 && !hasAll) {
        h += '<span class="ks-monthly__badge">-' + discountPercent + '%</span>';
      }
      h += '</div>';

      /* Timer */
      h += '<div class="ks-monthly__timer">';
      h += hasAll
        ? '<span>' + cfg.confirmedText + '<strong>' + timeStr + '</strong>' + cfg.confirmedSuffix + '</span>'
        : '<span>' + cfg.timerText + '<strong>' + timeStr + '</strong></span>';
      h += '</div>';

      if (hasAll) {
        h += '<div class="ks-monthly__confirmed">';
        h += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
        h += 'Dein ' + cfg.badge + ' ist im Warenkorb!</div>';
      } else if (notInCart.length) {
        h += '<div class="ks-monthly__products">';
        notInCart.forEach(function(p, idx) {
          var img = getImgSrc(p, '180x180');
          var preferredVar = prefer1kg(p);
          var priceCents = toCents(preferredVar ? preferredVar.price : 0);
          var vid = preferredVar ? preferredVar.id : 0;
          var avail = p.available;
          if (avail == null) avail = p.variants && p.variants.some(function(v) { return v.available !== false; });
          if (!avail && p.variants) avail = p.variants.some(function(v) { return v.inventory_policy === 'continue'; });
          var uid = 'kdm-' + p.handle + '-' + idx;

          h += '<div class="ks-card" data-ks-product-card>';
          h += '<div class="ks-card__head">';
          if (img) h += '<div class="ks-card__img"><img src="' + img + '" alt="" width="56" height="56" loading="lazy"></div>';
          h += '<div class="ks-card__title-wrap">';
          h += '<a href="/products/' + p.handle + '" class="ks-card__name">' + p.title + '</a>';
          h += '<span class="ks-card__price"><span data-ks-price>' + fmt(priceCents) + '</span>';
          if (discountPercent > 0) {
            h += ' <span class="ks-monthly__price-discount">\u00b7 ' + discountPercent + '% Rabatt</span>';
          }
          h += '</span>';
          h += '</div></div>';
          h += '<div class="ks-card__actions">';
          h += buildPickerHTML(p, uid);
          h += avail
            ? '<button type="button" class="ks-btn ks-btn--card ks-btn--accent" data-ks-add="' + vid + '" data-ks-discount="' + discountCode + '" data-ks-btn-text="' + (cfg.addBtnText || 'Jetzt sichern') + '">' + (cfg.addBtnText || 'Jetzt sichern') + '</button>'
            : '<span class="ks-card__soldout">Ausverkauft</span>';
          h += '</div>';
          h += '</div>';
        });
        h += '</div>';
      }
      h += '</div>';
      container.innerHTML = h;

      /* Picker-Events verdrahten */
      notInCart.forEach(function(p, idx) {
        var uid = 'kdm-' + p.handle + '-' + idx;
        wirePicker(container, p, uid, discountCode);
      });

      container.querySelectorAll('[data-ks-add]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var code = btn.getAttribute('data-ks-discount') || '';
          addToCart(btn.getAttribute('data-ks-add'), btn, code || null);
        });
      });

      setInterval(function() {
        var ts = getTimeStr(endDate);
        var el = container.querySelector('.ks-monthly__timer strong');
        if (!ts) container.innerHTML = '';
        else if (el) el.textContent = ts;
      }, 60000);
    }).catch(function(e) { console.log('[KS] KdM Fehler:', e); });
  }

  /* === RENDER: RECOMMENDATIONS === */

  function renderRecs(container, productIds, cartHandles) {
    var cfg = defined_KS_CONFIG.recs;
    if (!cfg) return;

    /* Empfehlungen ausblenden solange Limited-Produkt NICHT im Warenkorb ist */
    /* (deaktiviert — Limited-Produkt ausverkauft)
    var limitedCfg = defined_KS_CONFIG.limited || {};
    if (limitedCfg.handle && cartHandles.indexOf(limitedCfg.handle) === -1) {
      container.innerHTML = '';
      return;
    }
    */

    var p = !productIds.length
      ? fetchCollection(cfg.fallbackCollection || 'all', cartHandles, cfg.limit)
      : fetchRecs(productIds, cartHandles, cfg.limit).then(function(r) {
          return r.length ? r : fetchCollection(cfg.fallbackCollection || 'all', cartHandles, cfg.limit);
        });

    p.then(function(recs) {
      if (!recs || !recs.length) return;
      var btnText = cfg.addBtnText || 'Hinzufügen';
      var h = '<div class="ks-recs"><p class="ks-recs__title">\uD83D\uDCA1 ' + cfg.headline + '</p><div class="ks-recs__list">';

      recs.forEach(function(p, idx) {
        var img = getImgSrc(p, '120x120');
        var recVar = prefer1kg(p);
        var cents = toCents(recVar ? recVar.price : 0);
        var vid = recVar ? recVar.id : 0;
        var uid = 'rec-' + p.handle + '-' + idx;
        h += '<div class="ks-card ks-card--rec" data-ks-product-card>';
        h += '<div class="ks-card__head">';
        if (img) h += '<a href="/products/' + p.handle + '" class="ks-card__img"><img src="' + img + '" alt="" width="48" height="48" loading="lazy"></a>';
        h += '<div class="ks-card__title-wrap">';
        h += '<a href="/products/' + p.handle + '" class="ks-card__name">' + p.title + '</a>';
        h += '<span class="ks-card__price" data-ks-price>' + fmt(cents) + '</span>';
        h += '</div></div>';
        h += '<div class="ks-card__actions">';
        h += buildPickerHTML(p, uid);
        h += '<button type="button" class="ks-btn ks-btn--card ks-btn--outline" data-ks-add="' + vid + '" data-ks-btn-text="' + btnText + '">+ ' + btnText + '</button>';
        h += '</div></div>';
      });

      h += '</div></div>';
      container.innerHTML = h;

      /* Picker-Events verdrahten */
      recs.forEach(function(p, idx) {
        var uid = 'rec-' + p.handle + '-' + idx;
        wirePicker(container, p, uid, null);
      });

      container.querySelectorAll('[data-ks-add]').forEach(function(b) {
        b.addEventListener('click', function(e) { e.preventDefault(); addToCart(b.getAttribute('data-ks-add'), b); });
      });
    }).catch(function(e) { console.log('[KS] Recs Fehler:', e); });
  }

  /* === FIX INLINE STYLES === */
  var _fixing = false;

  function fixInlineStyles(cart) {
    if (!cart || _fixing) return;
    _fixing = true;
    try {
      cart.style.setProperty('transform', 'translateX(0)', 'important');
      cart.style.setProperty('padding-top', '0', 'important');

      var close = cart.querySelector('.ks-close[data-cart-close]');
      if (close) {
        close.style.setProperty('top', '50%', 'important');
        close.style.setProperty('transform', 'translateY(-50%)', 'important');
      }

      var scroll = cart.closest('.scroll, [data-cart-scroll]');
      if (scroll) {
        scroll.style.setProperty('padding', '0', 'important');
        scroll.style.setProperty('padding-top', 'env(safe-area-inset-top, 0)', 'important');
      }
    } finally {
      setTimeout(function() { _fixing = false; }, 50);
    }
  }

  /* === REFRESH CART DATA (initial load) === */
  function refreshCartData(cart) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var c = cart.querySelector('[data-ks-count]');
        if (c) c.textContent = '(' + d.item_count + ')';
        var b = cart.querySelector('[data-ks-btn-total]');
        if (b) b.textContent = formatMoney(d.total_price);
        cart.setAttribute('data-ks-cart-handles', d.items.map(function(i) { return i.handle; }).join(','));
        cart.setAttribute('data-ks-product-ids', d.items.map(function(i) { return i.product_id; }).join(','));
      })
      .catch(function() {});
  }

  /* === SYNC BTN TOTAL === */
  function syncBtnTotal(cart) {
    var t = cart.querySelector('[data-cart-total]');
    var b = cart.querySelector('[data-ks-btn-total]');
    if (!t || !b) return;
    new MutationObserver(function() {
      var txt = (t.textContent || '').trim();
      if (txt && txt !== b.textContent.trim()) b.textContent = txt;
    }).observe(t, { childList: true, characterData: true, subtree: true });
  }

  /* === WATCH CART CHANGES (Theme Qty/Remove) ===
     Wenn das Theme Items ändert (Löschen, Menge ändern),
     aktualisieren wir Shipping Bar, Count, Totals etc.
     Beobachtet [data-items-holder] auf childList-Änderungen. */
  var _refreshDebounce = null;
  function watchCartChanges(cart) {
    var itemsHolder = cart.querySelector('[data-items-holder]');
    if (!itemsHolder) return;
    new MutationObserver(function() {
      clearTimeout(_refreshDebounce);
      _refreshDebounce = setTimeout(function() {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(d) {
            /* Shipping bar + Truck aktualisieren */
            updateShippingBar(cart, d.total_price);

            /* Count */
            var c = cart.querySelector('[data-ks-count]');
            if (c) c.textContent = '(' + d.item_count + ')';

            /* Btn total */
            var b = cart.querySelector('[data-ks-btn-total]');
            if (b) b.textContent = formatMoney(d.total_price);

            /* Header count */
            updateHeaderCount(d.item_count);

            /* Cart data attributes */
            var handles = d.items.map(function(i) { return i.handle; });
            var ids = d.items.map(function(i) { return String(i.product_id); });
            cart.setAttribute('data-ks-cart-handles', handles.join(','));
            cart.setAttribute('data-ks-product-ids', ids.join(','));
            cart.setAttribute('data-ks-cart-total', String(d.total_price));
            cart.setAttribute('data-ks-item-count', String(d.item_count));

            /* KdM + Limited + Recs neu rendern */
            var monthly = cart.querySelector('[data-ks-monthly]');
            if (monthly) renderMonthly(monthly, handles);

            var limited = cart.querySelector('[data-ks-limited]');
            if (limited) renderLimited(limited, handles);

            var recs = cart.querySelector('[data-ks-recs]');
            if (recs) renderRecs(recs, ids, handles);
          })
          .catch(function() {});
      }, 300);
    }).observe(itemsHolder, { childList: true, subtree: true });
  }

  /* === RENDER: LIMITIERTES PRODUKT (Banner) === */

  function renderLimited(container, cartHandles) {
    var cfg = defined_KS_CONFIG.limited;
    if (!cfg || !cfg.handle) { container.innerHTML = ''; return; }

    /* Schon im Warenkorb? → nicht anzeigen */
    if (cartHandles.indexOf(cfg.handle) !== -1) {
      container.innerHTML = '';
      return;
    }

    fetch('/products/' + cfg.handle + '.json')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data || !data.product) { container.innerHTML = ''; return; }
        var p = data.product;
        var preferredVar = prefer1kg(p);
        var priceCents = toCents(preferredVar ? preferredVar.price : 0);
        var vid = preferredVar ? preferredVar.id : 0;
        var img = getImgSrc(p, '240x240');
        var avail = p.variants && p.variants.some(function(v) { return v.available !== false; });
        if (!avail) { container.innerHTML = ''; return; }

        var h = '<div class="ks-limited-banner">';
        h += '<div class="ks-limited-banner__badge">' + (cfg.emoji || '🔥') + ' ' + cfg.badge + '</div>';
        h += '<div class="ks-limited-banner__body">';
        if (img) h += '<div class="ks-limited-banner__img"><img src="' + img + '" alt="' + p.title + '" width="72" height="72" loading="lazy"></div>';
        h += '<div class="ks-limited-banner__info">';
        h += '<p class="ks-limited-banner__title">' + p.title + '</p>';
        h += '<p class="ks-limited-banner__claim">' + cfg.claim + '</p>';
        h += '<div class="ks-limited-banner__action">';
        h += '<span class="ks-limited-banner__price">' + fmt(priceCents) + '</span>';
        h += avail
          ? '<button type="button" class="ks-btn ks-btn--banner" data-ks-add="' + vid + '">' + (cfg.addBtnText || 'Hinzufügen') + '</button>'
          : '<span class="ks-card__soldout">Ausverkauft</span>';
        h += '</div></div></div></div>';

        container.innerHTML = h;

        container.querySelectorAll('[data-ks-add]').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            addToCart(btn.getAttribute('data-ks-add'), btn);
          });
        });
      })
      .catch(function(e) { console.log('[KS] Limited Fehler:', e); container.innerHTML = ''; });
  }

  /* === MAIN INIT === */
  function ksInit() {
    var cart = document.querySelector('#ks-cart:not([data-ks-init]), .ks-cart[data-cart]:not([data-ks-init])');
    if (!cart) return;
    cart.setAttribute('data-ks-init', '1');
    console.log('[KS] Cart Init v17');

    fixInlineStyles(cart);
    initShippingBar(cart);
    refreshCartData(cart);
    syncBtnTotal(cart);
    watchCartChanges(cart);
    initDiscount(cart);
    addExpressDivider(cart);
    addTrustBadges(cart);

    var ids = (cart.getAttribute('data-ks-product-ids') || '').split(',').filter(Boolean);
    var handles = (cart.getAttribute('data-ks-cart-handles') || '').split(',').filter(Boolean);

    var monthly = cart.querySelector('[data-ks-monthly]');
    if (monthly) renderMonthly(monthly, handles);

    var limited = cart.querySelector('[data-ks-limited]');
    if (limited) renderLimited(limited, handles);

    var recs = cart.querySelector('[data-ks-recs]');
    if (recs) renderRecs(recs, ids, handles);
  }

  /* === OBSERVER === */
  var debounce = null;
  new MutationObserver(function() {
    if (document.querySelector('#ks-cart:not([data-ks-init])') ||
        document.querySelector('.ks-cart[data-cart]:not([data-ks-init])')) {
      clearTimeout(debounce);
      debounce = setTimeout(ksInit, 150);
    }
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  /* Cart-Page */
  if (document.querySelector('.template-cart .ks-cart[data-cart]')) ksInit();

  /* Gestaffelte Timeouts */
  [150, 500, 1200, 3000].forEach(function(ms) {
    setTimeout(function() {
      var cart = document.querySelector('#ks-cart');
      if (cart && !cart.hasAttribute('data-ks-init')) ksInit();
      else if (cart) fixInlineStyles(cart);
    }, ms);
  });

})();
